import React, { useState } from 'react';
import { Box, Flex, useBreakpointValue } from '@chakra-ui/react';
import { useSwipeable } from 'react-swipeable';
import { SectionCard } from '../SectionCard';

const SwipableContent = ({ items }) => {
  const [offset, setOffset] = useState(0);
  const itemWidth = useBreakpointValue({ base: 200, md: 250 }); // Adjust based on screen size

  const handlers = useSwipeable({
    onSwipedLeft: () =>
      setOffset((prev) => Math.min(prev + itemWidth, (items.length - 1) * itemWidth)),
    onSwipedRight: () => setOffset((prev) => Math.max(prev - itemWidth, 0)),
    preventDefaultTouchmoveEvent: true,
    trackMouse: true,
  });

  return (
    <Box overflow='hidden' position='relative' {...handlers} width='100%'>
      <Flex transform={`translateX(-${offset}px)`} transition='transform 0.3s ease-out'>
        {items?.map((item, index) => (
          <Box key={item.id} minWidth={itemWidth} m={10} ml={index === 0 ? 20 : 5}>
            <SectionCard data={item} />
          </Box>
        ))}
      </Flex>
    </Box>
  );
};

export default SwipableContent;
